import addDays from 'date-fns/addDays';
import { TCheckInDateRangeResult, TDefaultDateRange } from '..';
import getTomorrow from './getTomorrow';

export default (defaultDate: TDefaultDateRange | null): TCheckInDateRangeResult | TDefaultDateRange => {
    const tomorrow = getTomorrow();
    return defaultDate || { from: tomorrow, to: addDays(tomorrow, 7) };
};